import React from 'react';
import AudiRingsLogo from './AudiRingsLogo';

const Header = (props) => (
    <header className="audi-forms__header">
        <div className="audi-forms__header-inner">
            <div className="row">
                <div className="col">
                    {props.children && (
                        <h1 className="aui-headline-3">{props.children}</h1>
                    )}
                </div>
                <div className="col-auto">
                    <AudiRingsLogo />
                </div>
            </div>
        </div>
    </header>
);

export default Header;
